export enum ProviderChoice {
    Control,
    Formula,
    Fixed
}
